import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-rental-form',
  templateUrl: './business-rental-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessRentalFormComponent extends LeadFormBase {
  @Input()
  formGroup!: FormGroup;

  constructor(private readonly fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: this.fb.control(InsuranceType.BUSINESS_RENTAL),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    this.formGroup.addControl('metadata', this.metadataFormGroup);
  }
}
